export const ICON_LIST_LAYOUT = {
  VERTICAL: 'Vertical',
  HORIZONTAL: 'Horizontal'
}
